import {FxeQuizQuestionController} from "./FxeQuizQuestionController";
import {LEVERAGE_2} from "../FxeQuizQuestions";
import {UserConfig} from "../../../types/UserConfig";
import {CurrentUserService} from "../../../services/user/CurrentUserService";

export const Leverage2 = "tfLeverage2Question";

export function leverage2() {
    return {
        templateUrl: "app/quiz/fxe/questions/Leverage2.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: Leverage2Controller
    };
}

export class Leverage2Controller extends FxeQuizQuestionController {
    public config = LEVERAGE_2;
}
